import { useMemo } from 'react';

import { PriceUtils } from '@ecp/common/src/utils/price/PriceUtils';

import useSiteInfo from '@mo-hooks/common/useSiteInfo';

export function useDisplayPrice(price, formattedPrice) {
  const priceUtils = new PriceUtils();
  const { priceFormat } = useSiteInfo();

  return useMemo(() => {
    if (priceUtils.isUsePriceFormat(priceFormat)) {
      return formattedPrice;
    } else {
      return price;
    }
  }, [formattedPrice, price, priceFormat]);
}
